import { useEffect } from "react";
import { useNavigate } from "react-router";
import Cookies from "universal-cookie";

interface LogoutProps {

}

export function Logout(props: LogoutProps) {

    const navigate = useNavigate();
    const cookies = new Cookies();

    // const userLogout = () => {
    //     // localStorage.clear()
    //     cookies.remove('auth',{ path: '/' })
    //     location.reload();
    //     navigate('/')
    // }

    useEffect(()=>{
        cookies.remove('auth',{ path: '/' })
    
        if(cookies.get('auth')== null){
            window.location.reload();
            navigate('/')
        }
        //window.location.reload();
        // navigate('/')
    },[])

    return (
        <>
           
        </>
    )
}